<template>
  <div class="sxy">
    <div v-wechat-title="$route.meta.title"></div>

    <!-- <div class="diandi"></div> -->
    <div class="dhtBox">
      <div class="cdBox">
      <div class="logo"></div>

        <div @click="shouye" class="cd">首页</div>
        <div @click="fuwu" class="cd">产品服务</div>
        <div @click="sxy" class="cd bxz">商学院</div>
        <div @click="cpgyl" class="cd">产品供应链</div>
        <div @click="hzal" class="cd">合作案例</div>
        <div @click="ydd( hsk )" class="cd yddapp">
          移动端
          <div class="yddxiazai" v-if="hsk == 2">
            <div class="hezi">
              <!-- <div class="img img1"></div> -->
              <!-- <div class="text">米商云</div> -->
            </div>
            <div class="hezi">
              <div class="img img2">
                <img src="../../assets/images/9774f492e19d7134dca0552612911f5.jpg" alt="">
              </div>
              <div class="text">米小礼</div>
            </div>
            <div class="hezi">
              <!-- <div class="img img3"></div> -->
              <!-- <div class="text">商e通</div> -->
            </div>
          </div>
        </div>
        <!-- <div @click="mk" class="cd">米珈</div> -->
        <div @click="gywm" class="cd">关于我们</div>

      </div>
    </div>
    <div class="lbBox">
      <div class="lbBoxtext1">米创商学院</div>
      <div class="lbBoxtext2">
        为企业实现智能营销的伙伴提供学习指导与资源合作的平台
      </div>
      <div class="lbBoxbtn" onclick = "javascript:document.getElementById('add').scrollIntoView()" style="cursor:pointer;">立即申请</div>
    </div>

    <div class="neirong1boxbox">
      <div class="neirong1box">
        <div class="neirong1boxleft"></div>
        <div class="neirong1boxright">
          <div class="neirong1boxrighttextbox">
            <div class="neirong1boxrighttextbox1">
              企 业 发 展 所 面 临 的 痛 点
            </div>
            <div class="neirong1boxrighttextbox2">
              D I F F I C U L T I E S E N C O U N T E R E D
            </div>
          </div>
          <div style="display: flex; flex-wrap: wrap">
            <div class="askjdtext askjdtext1">
              ● 为什么顾客不愿意进店停留更久？
            </div>
            <div class="askjdtext askjdtext2">● 为什么顾客不愿意进店？</div>
            <div class="askjdtext askjdtext3">● 为什么顾客不愿意买单？</div>
            <div class="askjdtext askjdtext4">● 为什么顾客不愿意持续消费？</div>
            <div class="askjdtext askjdtext5">● 为什么顾客不愿意持续消费？</div>
            <div class="askjdtext askjdtext6">● 为什么顾客不愿意传播？</div>
          </div>
        </div>
      </div>
    </div>

    <div class="neirong2boxbox">
      <div class="neirong2box">
        <div class="neirong2text">让营销变得简单，让增长自然而然</div>
        <div class="neirong2imgbox">
          <div class="neirong2imx">
            <div class="neirong2img neirong2img1"></div>
            <div class="neirong2text1">学习和交流</div>
            <div class="neirong2text2">
              通过商学院，定期组织主题性的学习交
              流活动，让您理清经营思路，实现业绩
              增长，企业间可以相互学习和借鉴智能 营销经验
            </div>
          </div>
          <div class="neirong2imx neirong2imgboxbj1"></div>
          <div class="neirong2imx">
            <div class="neirong2img neirong2img2"></div>
            <div class="neirong2text1">异业联盟营销</div>
            <div class="neirong2text2">
              集合优质联盟成员企业，打造有调性、有影响的线上和线下活动，为企业商家提供更多的资源合作和资源合作和资源互换机会，让我们一起抱团成长。
            </div>
          </div>
          <div class="neirong2imx neirong2imgboxbj2"></div>

          <div class="neirong2imx neirong2imgboxbj3"></div>

          <div class="neirong2imx">
            <div class="neirong2img neirong2img3"></div>
            <div class="neirong2text1">商家服务</div>
            <div class="neirong2text2">
              专业的运营服务团队，帮商家解答开店疑惑土突破运营瓶颈，实现业绩提升！强力打造“易企顺学员”，帮商家培养销售人才。
            </div>
          </div>
          <div class="neirong2imx neirong2imgboxbj4"></div>

          <div class="neirong2imx">
            <div class="neirong2img neirong2img4"></div>
            <div class="neirong2text1">打造标杆企业</div>
            <div class="neirong2text2">
              将经营优秀企业商家，作为运营成功案例通过联盟进行推广和宣传，提高曝光度和知名度，助力企业业绩增长。
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="neirong3boxbox">
      <div class="neirong3box">
        <div class="neirong3boxtext">商学院团队展示与介绍</div>
        <div class="neirong3boximgBox">
          <div class="neirong3boximg neirong3boximg1">
            <div class="neirong3boximgtextbox">
              <div class="neirong3boximgtext">商学院院长</div>
              <div class="neirong3boximgtextsbox">
                <div class="neirong3boximgtexts">米创集团董事长</div>
                <!-- <div class="neirong3boximgtexts">某某商业也会会长</div> -->
                <!-- <div class="neirong3boximgtexts">默默集董事长</div> -->
              </div>
            </div>
          </div>
          <div class="neirong3boximg neirong3boximg2">
            <div class="neirong3boximgtextbox">
              <div class="neirong3boximgtext">商学院副院长</div>
              <div class="neirong3boximgtextsbox">
                <div class="neirong3boximgtexts">米创集团副总经理</div>
                <!-- <div class="neirong3boximgtexts">某某商业也会会长</div> -->
                <!-- <div class="neirong3boximgtexts">默默集董事长</div> -->
              </div>
            </div>
          </div>
          <!-- <div class="neirong3boximg neirong3boximg1">
            <div class="neirong3boximgtextbox">
              <div class="neirong3boximgtext">商学院院长</div>
              <div class="neirong3boximgtextsbox">
                <div class="neirong3boximgtexts">某某商会会长</div>
                <div class="neirong3boximgtexts">某某商业也会会长</div>
                <div class="neirong3boximgtexts">默默集董事长</div>
              </div>
            </div>
          </div> -->
          <!-- <div class="neirong3boximg neirong3boximg1">
            <div class="neirong3boximgtextbox">
              <div class="neirong3boximgtext">商学院院长</div>
              <div class="neirong3boximgtextsbox">
                <div class="neirong3boximgtexts">某某商会会长</div>
                <div class="neirong3boximgtexts">某某商业也会会长</div>
                <div class="neirong3boximgtexts">默默集董事长</div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <!-- <div class="neirongBoxbox">
      <div class="neirongbox">
        <div class="biaoti">私域流量运营的策略核心</div>
        <div class="biaoqixiangqing">
          反厂制由总带中片米气电连于调共被级料大四的骄傲ID啊搜地阿吉豆阿斯到底阿萨德大多手打阿萨德
          阿斯到底阿萨德大多手打阿斯到底阿萨德大多手打
        </div>
        <div class="neironghezi" style="margin-bottom: 1.3rem">
          <div class="neirongtext">
            <div class="img img1"></div>
            <div class="text1">本地SKU</div>
            <div class="text2">
              大大高效管理私有管理私有商城 高效管理订单管理私有管理私有
              高效管理客户信息管理私有
            </div>
          </div>
          <div class="neirongtext">
            <div class="img img2"></div>
            <div class="text1">本地SKU</div>
            <div class="text2">
              大大高效管理私有管理私有商城 高效管理订单管理私有管理私有
              高效管理客户信息管理私有
            </div>
          </div>
          <div class="neirongtext">
            <div class="img img3"></div>
            <div class="text1">本地SKU</div>
            <div class="text2">
              大大高效管理私有管理私有商城 高效管理订单管理私有管理私有
              高效管理客户信息管理私有
            </div>
          </div>
        </div>
        <div class="neironghezi">
          <div class="neirongtext">
            <div class="img img1"></div>
            <div class="text1">本地SKU</div>
            <div class="text2">
              大大高效管理私有管理私有商城 高效管理订单管理私有管理私有
              高效管理客户信息管理私有
            </div>
          </div>
          <div class="neirongtext">
            <div class="img img2"></div>
            <div class="text1">本地SKU</div>
            <div class="text2">
              大大高效管理私有管理私有商城 高效管理订单管理私有管理私有
              高效管理客户信息管理私有
            </div>
          </div>
          <div class="neirongtext">
            <div class="img img3"></div>
            <div class="text1">本地SKU</div>
            <div class="text2">
              大大高效管理私有管理私有商城 高效管理订单管理私有管理私有
              高效管理客户信息管理私有
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="biaogeboxs">
      <div class="biaoge">
        <div class="biaogetext1">米创商学院定位</div>
        <div class="biaogetext2box">
          <div class="biaogetext2_1">1.致力于为中国实体商家插上新零售数字经济翅膀；</div>
          <div class="biaogetext2_1">2.致力于为中国实体商家插上新零售数字经济翅膀；</div>
        </div>
        <div class="biaogetext3box">3.用互联网思维打造实体商家的“免费”营销模式</div>
        <div class="biaogetext4box">米创商学院接下来的课程安排:</div>
        <div class="xbgbox">
          <div class="xbgboxs">
            <div class="wenzi1">米小礼应用</div>
            <div class="wenzi2">米小礼积分商城功能普及</div>
          </div>
           <div class="xbgboxs">
            <div class="wenzi1">米商云应用</div>
            <div class="wenzi2">实体如何布局新零售</div>
          </div>
           <div class="xbgboxs">
            <div class="wenzi1">米小包</div>
            <div class="wenzi2">新零售营销互动工具玩法</div>
          </div>
           <div class="xbgboxs">
            <div class="wenzi1">一折爆品</div>
            <div class="wenzi2">免费营销的玩法</div>
          </div>
           <div class="xbgboxs">
            <div class="wenzi1">米创会员营销玩法</div>
            <div class="wenzi2">爆品初级营销玩法</div>
          </div>
           <div class="xbgboxs">
            <div class="wenzi1">爆品初级营销玩法</div>
            <div class="wenzi2">资源整合方案</div>
          </div>
           <div class="xbgboxs">
            <div class="wenzi1">米创会员享受服务解析</div>
            <div class="wenzi2">如何消费价值最大化</div>
          </div>
           <div class="xbgboxs">
            <div class="wenzi1">商业模式策划</div>
            <div class="wenzi2">如何成为米创商业模式策
划是</div>
          </div>
        </div>
      </div>
    </div>
    <div class="tijiaoboxbox" id="add" >
      <div class="tijiaobox">
        <div class="biaoti">营销落地 顺势而为</div>
        <div class="biaogebox">
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="姓名"
              id="txt"
              value=""
              ref="name1"
              v-on:keyup="inputRef1"
            />
          </div>
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="手机"
              id="txt"
              value=""
              ref="name2"
              v-on:keyup="inputRef2"
            />
          </div>
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="公司名称"
              id="txt"
              value=""
              ref="name3"
              v-on:keyup="inputRef3"
            />
          </div>
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="省份"
              id="txt"
              value=""
              ref="name4"
              v-on:keyup="inputRef4"
            />
          </div>
        </div>
        <div class="tijiaobtn" @click="ziliao()">立即申请</div>
      </div>
    </div>
  </div>
</template>
<script>
import API from "@/service/common.service.js";
export default {
  data() {
    //

    return {
      name1: "name1",
      name2: "name2",
      name3: "name3",
      name4: "name4",
      hsk:1,

    };
  },
  mounted() {
    // window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    inputRef1: function () {
      console.log(this.$refs.name1.value);
      this.name1 = this.$refs.name1.value;
    },
    inputRef2: function () {
      console.log(this.$refs.name2.value);
      this.name2 = this.$refs.name2.value;
    },
    inputRef3: function () {
      console.log(this.$refs.name3.value);
      this.name3 = this.$refs.name3.value;
    },
    inputRef4: function () {
      console.log(this.$refs.name4.value);
      this.name4 = this.$refs.name4.value;
    },
    ziliao() {
      console.log(this.name1);
      console.log(this.name2);
      console.log(this.name3);
      console.log(this.name4);
      if (
        this.name1 == "" ||
        this.name1 == "name1" ||
        this.name1 == undefined
      ) {
        this.$toast("请输入您的姓名");
      } else if (
        this.name2 == "" ||
        this.name2 == "name2" ||
        this.name2 == undefined
      ) {
        this.$toast("请输入您的手机号");
      } else if (
        this.name3 == "" ||
        this.name3 == "name3" ||
        this.name3 == undefined
      ) {
        this.$toast("请输入您的公司名称");
      } else if (
        this.name4 == "" ||
        this.name4 == "name4" ||
        this.name4 == undefined
      ) {
        this.$toast("请输入您的省份");
      } else {
        this.tech_www();
      }
    },
    ydd(e){
       if(e == 1){
        this.hsk = 2
      }else{
        this.hsk = 1

      }
      console.log(this.hsk)
      
    },
shouye() {
      this.$router.push({
        path: "/",
      });
    },
    fuwu() {
      this.$router.push({
        path: "/cpfu",
      });
    },
    sxy() {
      this.$router.push({
        path: "/sxy",
      });
    },
    cpgyl() {
      this.$router.push({
        path: "/cpgyl",
      });
    },
    hzal() {
      this.$router.push({
        path: "/hzal",
      });
    },
    mk() {
      this.$router.push({
        path: "/mk",
      });
    },
    gywm() {
      this.$router.push({
        path: "/gywm",
      });
    },
    // 数据提交
    tech_www() {
      let form_data = new FormData();
      // 姓名
      form_data.append("name", this.name1);
      // 电话
      form_data.append("jobs", this.name2);
      // 需求
      form_data.append("company", this.name3);
      // 省份
      form_data.append("province", this.name4);
      // // 身份证反面照片
      // form_data.append("idcardReversePhoto", this.idcardReversePhoto);

      API.tech_www(form_data).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          // this.typeofwork = res.data.dicList;
          // this.$router.push({
          //   path: "/success"
          // });
          this.$toast(res.data.msg);
        } else {
          // 弹出返回文字
          this.$toast(res.data.msg);
        }
      });
    },
    // 提交数据接口
  },
};
</script>

<style lang="scss">
.sxy {
  font-size: 0.16rem;
  background: #fff;
    .dhtBox{
    .bxz{
      border-bottom: 2px solid #fff;
    }
  }
  .lbBox {
    width: 100%;
    height: 5.17rem;
    background: url("../../../src/assets/images/1068.png");
    background-size: 100% 100%;
    // position: absolute;
    // top: 0;
    z-index: -1;
    margin-top: -0.98rem;
    padding-top: 1.9rem;
    box-sizing: border-box;
    .lbBoxtext1 {
      font-size: 0.6rem;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      text-align: center;
      margin-bottom: 0.4rem;
    }
    .lbBoxtext2 {
      font-size: 0.18rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #fffefe;
      line-height: 0.38rem;
      margin-bottom: 0.8rem;
      text-align: center;
    }
    .lbBoxbtn {
      width: 1.62rem;
      height: 0.5rem;
      border: 2px solid #ffffff;
      border-radius: 10px;
      font-size: 0.2rem;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .neirong1boxbox {
    width: 100%;
    background: #fff;
    padding-bottom: 0.86rem;
    .neirong1box {
      width: 1200px;
      margin: 0 auto;
      padding-top: 0.7rem;
      display: flex;
      .neirong1boxleft {
        width: 6.62rem;
        height: 4.65rem;
        background: url("../../assets/images/-50159.png") no-repeat center;
        background-size: 100% 100%;
        margin-right: 0.2rem;
      }
      .neirong1boxright {
        width: 5.2rem;
        .neirong1boxrighttextbox {
          margin-bottom: 0.6rem;
          .neirong1boxrighttextbox1 {
            font-size: 0.34rem;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #2a2e2e;
          }
        }
        .neirong1boxrighttextbox2 {
          font-size: 0.2rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #2d60fe;
          line-height: 0.38rem;
        }
        .askjdtext {
          height: 0.48rem;
          background: #ffffff;
          border: 1px solid #e2e2e2;
          border-radius: 0.24rem;
          display: flex;
          justify-content: left;
          align-items: center;
          padding-left: 0.15rem;
          box-sizing: border-box;
          font-size: 0.14rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #666666;
          letter-spacing: 0.02rem;
          margin-right: 0.15rem;
          margin-bottom: 0.32rem;
        }
        .askjdtext1 {
          // width: 2.99rem;
        }
        .askjdtext2 {
          // width: 2.31rem;
        }
      }
    }
  }
  .neirong2boxbox {
    width: 100%;
    background: #fbfbfb;
    padding-bottom: 1.2rem;
    .neirong2box {
      width: 1200px;
      margin: 0 auto;
      padding-top: 1.15rem;
      box-sizing: border-box;
      .neirong2text {
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #222222;
        text-align: center;
        margin-bottom: 1.48rem;
      }
      .neirong2imgbox {
        height: 5.4rem;
        display: flex;
        flex-wrap: wrap;
        .neirong2imx {
          width: 3rem;
          height: 2.7rem;
          padding: 0.25rem;
          box-sizing: border-box;
          .neirong2img {
            width: 0.47rem;
            height: 0.47rem;
            margin-bottom: 0.3rem;
            margin-right: 2rem;
          }
          .neirong2img1 {
            background: url("../../assets/images/-50802.png") no-repeat center;
          }
          .neirong2img2 {
            background: url("../../assets/images/-50816.png") no-repeat center;
          }
          .neirong2img3 {
            background: url("../../assets/images/-50803.png") no-repeat center;
          }
          .neirong2img4 {
            background: url("../../assets/images/-50818.png") no-repeat center;
          }
          .neirong2text1 {
            font-size: 0.2rem;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #222222;
            margin-bottom: 0.2rem;
          }
          .neirong2text2 {
            font-size: 0.14rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #868686;
          }
        }
        .neirong2imgboxbj1 {
          background: url("../../assets/images/a1232.png") no-repeat center;
          background-size: 100% 100%;
        }
        .neirong2imgboxbj2 {
          background: url("../../assets/images/1108.png") no-repeat center;
          background-size: 100% 100%;
        }
        .neirong2imgboxbj3 {
          background: url("../../assets/images/11081.png") no-repeat center;
          background-size: 100% 100%;
        }
        .neirong2imgboxbj4 {
          background: url("../../assets/images/110831.png") no-repeat center;
          background-size: 100% 100%;
        }
      }
    }
  }
  .neirong3boxbox {
    width: 100%;
    background: #fff;
    padding-bottom: 1.5rem;
    .neirong3box {
      width: 1200px;
      margin: 0 auto;
      padding-top: 1.12rem;
      .neirong3boxtext {
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #222222;
        text-align: center;
        margin-bottom: 0.8rem;
      }
      .neirong3boximgBox {
        display: flex;
        flex-wrap: wrap;
        .neirong3boximg {
          width: 5.51rem;
          height: 6.49rem;
          background-size: 100% 100%;
          margin-right: 0.97rem;
          position: relative;
          margin-bottom: 0.5rem;
          .neirong3boximgtextbox {
            width: 2.3rem;
            height: 2.2rem;
            background: #2d60fe;
            opacity: 0.9;
            position: absolute;
            bottom: -0.16rem;
            right: -0.16rem;
            padding-top: 0.25rem;
            box-sizing: border-box;
            .neirong3boximgtext {
              font-size: 0.31rem;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #ffffff;
              text-align: center;
              margin-bottom: 0.2rem;
            }
            .neirong3boximgtextsbox {
              .neirong3boximgtexts {
                font-size: 0.18rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #ffffff;
                line-height: 0.32rem;
                text-align: center;
              }
            }
          }
        }
        .neirong3boximg:nth-child(2n) {
          margin-right: 0;
        }
        .neirong3boximg1 {
          background: url("../../assets/images/dfbd86bba0c489d9ef505cf4efdf212.png") no-repeat center;
        }
        .neirong3boximg2 {
          background: url("../../assets/images/0b5ee7a5cc6a766257bdbadb052dd6b.png") no-repeat center;
        }
        // .neirong3boximg3 {
        //   background: url("../../assets/images/98951.png") no-repeat center;
        // }
        // .neirong3boximg3 {
        //   background: url("../../assets/images/98951.png") no-repeat center;
        // }
      }
    }
  }
.biaogeboxs{
  width: 100%;
  background: #fff;
  .biaoge{
    width: 1200px;
    margin: 0 auto;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    .biaogetext1{
      text-align: center;
      font-size: 0.48rem;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #000000;
      margin-bottom: 0.4rem;
    }
    .biaogetext2box{
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #666666;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0.1rem;

      .biaogetext2_1{
      font-size: 0.20rem;
      font-weight: 300;
      }
    }
    .biaogetext3box{
       font-size: 0.20rem;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #666666;
      text-align: center;
      margin-bottom: 0.6rem;
    font-weight: 300;

    }
    .biaogetext4box{
      font-size: 0.20rem;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #3B6AFD;
      text-align: center;
      margin-bottom: 0.2rem;
    }
    .xbgbox{
      border-top: 1px solid #EAEAEA;
      // border-bottom: 1px solid #EAEAEA;
      display: flex;
      flex-wrap: wrap;
      .xbgboxs{
      width: 5.99rem;
      height: 0.59rem;
      display: flex;
      align-items: center;
      border-right: 1px solid #EAEAEA;
      border-bottom: 1px solid #EAEAEA;
      .wenzi1{
        font-size: 0.20rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #1E1E1E;
        width: 3.55rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
      .wenzi2{
        width: 2.4rem;
        font-size: 0.16rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #868686;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
      
    }
    .xbgboxs:nth-child(2n){
        .wenzi1{
          padding-left: 0.78rem;
          box-sizing: border-box;
        }
      }
    }
    
  }
}

  .neirongBoxbox {
    width: 100%;
    background: #fbfbfb;
    padding-bottom: 1.2rem;
    .neirongbox {
      width: 1200px;
      height: 10.86rem;
      margin: 0 auto;
      .biaoti {
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #2a2e2e;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 1rem;
        margin-bottom: 0.35rem;
        box-sizing: border-box;
      }
      .biaoqixiangqing {
        width: 6.2rem;
        font-size: 0.14rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #868686;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        text-align: center;
        margin: 0 auto;
        line-height: 0.34rem;
        margin-bottom: 1.5rem;
      }
      .biaoqixiangqings {
        margin-bottom: 1rem;
      }
      .neironghezi {
        display: flex;

        .neirongtext {
          width: 3.86rem;
          height: 2.7rem;
          background: #ffffff;
          border-radius: 0.2rem;
          margin-bottom: 0.2rem;
          margin-right: 0.2rem;
          .img {
            width: 1.42rem;
            height: 1.42rem;
            margin: 0 auto;
            margin-top: -0.6rem;
            margin-bottom: 0.12rem;
          }
          .img1 {
            background: url("../../assets/images/19.png");
          }
          .img2 {
            background: url("../../assets/images/20.png");
          }
          .img3 {
            background: url("../../assets/images/21.png");
          }
          .text1 {
            font-size: 0.22rem;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #101127;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 0.32rem;
          }
          .text2 {
            width: 2.42rem;
            font-size: 0.14rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #868686;
            line-height: 0.29rem;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto;
            text-align: center;
          }
        }
        .neirongtext:nth-child(3) {
          margin-right: 0rem;
        }
        .neirongtexts {
          box-shadow: -0.01rem 0.05rem 0.16rem 0rem #deeefd;
          width: 5.47rem;
          margin-right: 1.06rem;
        }
        .neirongtext:hover {
          box-shadow: -0.01rem 0.05rem 0.16rem 0rem #deeefd;
        }
        .img {
          width: 1.42rem;
          height: 1.42rem;
          background: url("../../assets/images/-48612.png");
          margin-right: 0.42rem;
        }
        .textbox {
          width: 1024px;
          .text1 {
            font-size: 0.26rem;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #000000;
            margin-top: 0.2rem;
            margin-bottom: 0.3rem;
          }
          .text2 {
            font-size: 0.14rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #868686;
            line-height: 0.3rem;
          }
        }
      }
    }
  }
    .tijiaoboxbox {
    width: 100%;
    background: url("../../assets/images/jiao.png") no-repeat center;
    background-size: 100% 100%;
    .tijiaobox {
      width: 1200px;
      height: 4.64rem;
      margin: 0 auto;
      .biaoti {
        font-size: 0.42rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        padding-top: 0.75rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0.9rem;
      }
      .biaogebox {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 1rem;
        .biaoge {
          width: 2.76rem;
          height: 0.42rem;
          background: #ffffff;
          border-radius: 0.1rem;
          margin-left: 0.11rem;
          margin-right: 0.11rem;
          .index {
            width: 100%;
            height: 100%;
            padding-left: 0.2rem;
            box-sizing: border-box;
            border-radius: 0.1rem;
            border: none;
          }
        }
      }
      .tijiaobtn {
        width: 1.62rem;
        height: 0.5rem;
        border: 0.02rem solid #ffffff;
        border-radius: 0.1rem;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.2rem;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/sxy/index.vue